const Styles = {
    SIDE_PADDING: '20px',
    ROW_PADDING: '10px',
    SCREEN_WIDTH: 1191,
}

export default Styles
